module.exports = {
  title: '工单系统',
  //顶部栏
  fixedHeader: true,
  //侧边栏logo
  sidebarLogo: true,
  //侧边栏title
  sidebarTitle: '工单系统',
  // 底部栏
  footer: true,
  //系统编号
  sysAppId: '',
  // 本地登录 在页面搭建初期，不请求接口时可用 true ，跳过登录请求，显示本地配置
  isLocal: false
}



// WEBPACK FOOTER //
// ./src/settings.js